<div class="place-card-container">
  <div class="img-card">
    <img [src]="saloon.imgUrl" [alt]="saloon.name" loading="lazy" />
    @if (formattedDistance) {
    <span class="distance-badge">{{ formattedDistance }}</span>
    }
  </div>
  <div class="title-img">
    <h1>{{ saloon.name }}</h1>
    <p>
      <img class="icon-visitors" src="assets/icons/visitors.svg" alt="icons visitors" />
      @if (visitorCount === 0) { Aucun visiteur } @else {
      {{ visitorCount }} visiteur{{ visitorCount > 1 ? 's' : '' }}
      }
    </p>
  </div>
</div>
